import React from "react";

const ComingSoon = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Bientôt Disponible</h1>
      <p style={styles.description}>
        Le site du Professeur Ousmane est en cours de développement. Revenez
        bientôt pour découvrir nos services exceptionnels.
      </p>
      <div style={styles.socialIcons}>
        <a
          href="https://www.facebook.com/professeurousmane"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          Facebook
        </a>
        <a
          href="https://www.instagram.com/professeurousmane"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          Instagram
        </a>
      </div>
      <p style={styles.contact}>
        Contactez-nous à :{" "}
        <a
          href="mailto:professeurousmane072@gmail.com"
          style={styles.emailLink}
        >
          professeurousmane072@gmail.com
        </a>
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "linear-gradient(to right, #3b3b3b, #121212)",
    color: "#fff",
    textAlign: "center",
    padding: "20px",
  },
  title: {
    fontSize: "3rem",
    marginBottom: "1rem",
  },
  description: {
    fontSize: "1.2rem",
    marginBottom: "2rem",
  },
  socialIcons: {
    marginBottom: "2rem",
  },
  link: {
    margin: "0 10px",
    color: "#00d084",
    textDecoration: "none",
    fontSize: "1.5rem",
  },
  contact: {
    marginTop: "2rem",
    fontSize: "1rem",
  },
  emailLink: {
    color: "#00d084",
    textDecoration: "none",
  },
};

export default ComingSoon;
